import type { ReactNode } from 'react';

import cn from 'classnames';

import styles from './ApplicationDataSection.module.scss';

interface IProp {
  icon: ReactNode;
  title: string;
  dataValue: string;
  theme?: 'primary' | 'secondary';
  className?: string;
}

export const ApplicationDataSection = ({ icon, title, dataValue, theme = 'primary', className }: IProp) => (
  <div className={cn(styles.wrapper, className)}>
    <div className={cn(styles['icon-wrapper'], styles[`icon-wrapper-${theme}`])}>{icon}</div>
    <div className={styles['text-wrapper']}>
      <p className={styles.title}>{title}</p>
      <p className={styles.value}>{dataValue}</p>
    </div>
  </div>
);
